export default "__VITE_ASSET__CnK6rcNW__"